<!-- Start Hero -->
<section class="relative table w-full py-36 bg-[url('/assets/images/parallax/archer_1920x1200.jpg')] bg-center bg-no-repeat">
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900"></div>
  <div class="container">
    <div class="grid grid-cols-1 pb-8 text-center mt-10">
      <h3 class="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">{{ `ARTICLES.${pageName}` | translate }}</h3>
    </div><!--end grid-->
  </div><!--end container-->
</section><!--end section-->

<!-- Start -->
<section class="relative md:py-24 py-16">
  <div class="container">
    <div *ngIf="loading" class="flex justify-center items-center py-10">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
    </div>
    <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px]">
      <div *ngFor="let article of articles" class="group relative overflow-hidden bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-700 hover:shadow-md transition-all duration-500">
        <img *ngIf="article.thumbnailImage" [src]="article.thumbnailImage" alt="">
        <img *ngIf="!article.thumbnailImage" src="/assets/images/no-img.jpg" alt="">

        <div class="relative p-6">
          <div class="absolute start-6 -top-4">
            <span class="bg-violet-600 text-white text-[12px] px-2.5 py-1 font-semibold rounded-full h-5">{{ `ARTICLES.${article.category}` | translate}}</span>
          </div>

          <div class="">
            <div class="flex mb-4">
              <span class="text-slate-400 text-[16px]"><i class="uil uil-calendar-alt text-slate-900 dark:text-white me-2"></i>{{article.updateTime || article.createTime | date:'mediumDate'}}</span>
              <span class="text-slate-400 text-[16px] ms-3"><i class="uil uil-clock text-slate-900 dark:text-white me-2"></i>{{article.readTime}} {{ 'BLOG.READ_MIN' | translate }}</span>
            </div>

            <a [routerLink]="['/read', article.id]" class="title text-lg font-medium hover:text-violet-600 duration-500 ease-in-out">{{article.title}}</a>

            <div class="flex justify-between mt-4">
              <a [routerLink]="['/read', article.id]" class="btn btn-link text-[16px] font-medium hover:text-violet-600 after:bg-violet-600 duration-500 ease-in-out">{{ 'BLOG.READ_MORE' | translate }} <i class="uil uil-arrow-right"></i></a>
              <span class="text-slate-400 text-[16px]">by <a [routerLink]="'/creator-profile'" class="text-slate-900 dark:text-white hover:text-violet-600 dark:hover:text-violet-600 font-medium">{{article.author}}</a></span>
            </div>
          </div>
        </div>
      </div>
      <!--end content-->
    </div><!--end grid-->

    <div class="grid md:grid-cols-12 grid-cols-1 mt-8">
      <div class="md:col-span-12 text-center">
        <nav>
          <ul class="inline-flex items-center -space-x-px">
            <li>
              <a
                href="#"
                (click)="changePage(currentPage - 1, $event)"
                [class.disabled]="currentPage === 0"
                class="w-10 h-10 inline-flex justify-center items-center mx-1 rounded-full text-slate-400 bg-white dark:bg-slate-900 hover:text-white shadow-sm dark:shadow-gray-700 hover:border-violet-600 dark:hover:border-violet-600 hover:bg-violet-600 dark:hover:bg-violet-600">
                <i class="uil uil-angle-left text-[20px]"></i>
              </a>
            </li>

            <li *ngFor="let page of visiblePages">
              <a
                href="#"
                (click)="changePage(page, $event)"
                [class.active]="page === currentPage"
                class="w-10 h-10 inline-flex justify-center items-center mx-1 rounded-full text-slate-400 bg-white dark:bg-slate-900 shadow-sm dark:shadow-gray-700 hover:border-violet-600 dark:hover:border-violet-600 hover:bg-violet-600 dark:hover:bg-violet-600"
                [ngClass]="{'z-10 text-white bg-violet-600': page === currentPage}">
                {{ page + 1 }}
              </a>
            </li>

            <li>
              <a
                href="#"
                (click)="changePage(currentPage + 1, $event)"
                [class.disabled]="currentPage === (pageInfo?.page?.totalPages ?? 0) - 1"
                class="w-10 h-10 inline-flex justify-center items-center mx-1 rounded-full text-slate-400 bg-white dark:bg-slate-900 hover:text-white shadow-sm dark:shadow-gray-700 hover:border-violet-600 dark:hover:border-violet-600 hover:bg-violet-600 dark:hover:bg-violet-600">
                <i class="uil uil-angle-right text-[20px]"></i>
              </a>
            </li>

          </ul>
        </nav>
      </div>
    </div><!--end grid-->
  </div><!--end container-->
</section><!--end section-->
<!-- End -->
